import { c as _c } from "react/compiler-runtime";
import { type CSSProperties, type FC } from "react";
interface StatBarProps {
  label: string;
  percentage: number;
  colorClass?: string;
  valueLabel?: string;
}
export const StatBar: FC<StatBarProps> = t0 => {
  const $ = _c(15);
  const {
    label,
    percentage,
    colorClass: t1,
    valueLabel
  } = t0;
  const colorClass = t1 === undefined ? "bg-brand-500" : t1;
  let t2;
  if ($[0] !== label) {
    t2 = <span className="text-xs font-medium text-slate-600 dark:text-slate-300">{label}</span>;
    $[0] = label;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = valueLabel || `${percentage}%`;
  let t4;
  if ($[2] !== t3) {
    t4 = <span className="text-xs font-bold font-mono text-slate-900 dark:text-white">{t3}</span>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <div className="flex justify-between mb-1">{t2}{t4}</div>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `h-2.5 rounded-full ${colorClass} animate-grow-width`;
  const t7 = `${percentage}%`;
  let t8;
  if ($[7] !== t7) {
    t8 = {
      "--target-width": t7
    };
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = t8 as CSSProperties;
  let t10;
  if ($[9] !== t6 || $[10] !== t9) {
    t10 = <div className="w-full bg-slate-200 dark:bg-slate-800 rounded-full h-2.5"><div className={t6} style={t9} /></div>;
    $[9] = t6;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t5) {
    t11 = <div className="mb-4">{t5}{t10}</div>;
    $[12] = t10;
    $[13] = t5;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  return t11;
};